import React from 'react';

const ScreenshotModal = ({ isOpen, onClose, websiteScreenshot, mainUrl, screenshotLabel = '' }) => {
    if (!isOpen || !websiteScreenshot) {
        return null;
    }

    return (
        <div
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(0, 0, 0, 0.9)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 9999,
                padding: '20px'
            }}
            onClick={onClose}
        >
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: '12px'
                }}
                onClick={(e) => e.stopPropagation()}
            >
                {screenshotLabel && (
                    <div
                        style={{
                            color: '#f0f0f0',
                            fontSize: '14px',
                            textTransform: 'uppercase',
                            letterSpacing: '0.6px'
                        }}
                    >
                        {screenshotLabel}
                    </div>
                )}
                <img
                    src={`data:image/png;base64,${websiteScreenshot}`}
                    alt={`Screenshot of ${mainUrl}`}
                    style={{
                        maxWidth: '95%',
                        maxHeight: '85vh',
                        width: 'auto',
                        height: 'auto',
                        borderRadius: '4px',
                        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.5)',
                        objectFit: 'contain'
                    }}
                />
            </div>
            <button
                onClick={onClose}
                style={{
                    position: 'absolute',
                    top: '20px',
                    right: '20px',
                    backgroundColor: '#dc3545',
                    color: '#fff',
                    border: 'none',
                    borderRadius: '50%',
                    width: '40px',
                    height: '40px',
                    fontSize: '24px',
                    cursor: 'pointer',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    fontWeight: 'bold',
                    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.3)'
                }}
                onMouseEnter={(e) => {
                    e.target.style.backgroundColor = '#c82333';
                }}
                onMouseLeave={(e) => {
                    e.target.style.backgroundColor = '#dc3545';
                }}
            >
                ×
            </button>
        </div>
    );
};

export default ScreenshotModal;

